import React from 'react';

interface InstagramIconProps {
  w?: number;
  h?: number;
  disabled?: boolean;
}

export function InstagramIcon({ w = 16, h = 16, disabled = false }: InstagramIconProps) {
  return (
    <svg
      width={w}
      height={h}
      opacity={disabled ? 0.5 : 1}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" fill="url(#pattern0_2_6542)" />
    </svg>
  );
}
